import {call, put} from "typed-redux-saga";
import {Api} from "modules/utils";
import {fetchRoundsFailed, fetchRoundsSuccess, setContestsForLeagues} from "modules/actions";
import {get, sortBy} from "lodash";

const ROUND_TRANSLATIONS = {
	4: "league.filters.weekdropdown_r16",
	5: "league.filters.weekdropdown_qf",
	6: "league.filters.weekdropdown_sf",
	7: "league.filters.weekdropdown_final",
};

export const fetchRoundsSaga = function* () {
	try {
		const result = yield* call(Api.JSON.rounds);
		const sortRounds = sortBy(result, "id");
		yield* put(fetchRoundsSuccess(sortRounds));

		const contestsForLeagues = sortRounds.map(({id, status}) => ({
			id,
			status,
			roundNumber: id,
			translationKey: get(ROUND_TRANSLATIONS, id, "league.filters.weekdropdown"),
		}));
		yield* put(setContestsForLeagues(contestsForLeagues));
	} catch (err) {
		yield* put(fetchRoundsFailed());
	}
};
